import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogout() {
  const navigate = useNavigate();

  useEffect(() => {
    // local storage clear
    localStorage.removeItem("adminLoggedIn");

    // redirect to login page
    navigate("/adminLogin");
  }, [navigate]);

  return null;
}

export default AdminLogout;
